import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { GetUserTransactionsDataTypes } from "../../../../Schema/getUserTransactions.types";

export type GetUserTransactionsLoadAction = {
  type: string;
  payload: { page: number; types?: string | null };
};

export type GetUserTransactionsData = {
  data: {
    data: GetUserTransactionsDataTypes;
  };
};

const GetUserTransactions = new ReduxFetchState<
  GetUserTransactionsData | null,
  { page: number; types?: string | null },
  any
>("getUserTransactions");

export function* watchGetUserTransactions(action: GetUserTransactionsLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: GetUserTransactionsData = yield axios({
      url: `/api/v1/users/wallet/transactions?page=${action.payload.page}${action.payload.types ? `&type=${action.payload.types}` : ""}`,
      method: "GET",
      headers: {
        lang,
      },
    });

    yield put(GetUserTransactions.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    yield put(GetUserTransactions.actions.loadFailure(e?.response?.data));
  }
}

export function* getUserTransactionsSagas() {
  yield takeEvery(GetUserTransactions.actionTypes.load, watchGetUserTransactions);
}

export function useGetUserTransactions() {
  const { loading, data, ...getUserTransactionsState } = useAppSelector(
    (state) => state.getUserTransactions,
  );
  const dispatch = useAppDispatch();

  const dispatchGetUserTransactions = useCallback(
    (data: { page: number; types?: string | null }) => {
      dispatch(GetUserTransactions.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...getUserTransactionsState,
    dispatchGetUserTransactions,
    getUserTransactionsLoading: loading,
    getUserTransactionsData: data,
  };
}

export const {
  actionTypes: getUserTransactionsActionsTypes,
  actions: getUserTransactionsActions,
  reducer: getUserTransactionsReducer,
} = GetUserTransactions;
